
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_emp',
        label: 'Empresa',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-custom',
        field: 'id_fdt',
        label: 'Frente de Trabalho',
        option: {
            key: 'id',
            label: 'fdt',
            value: 'id'
        },
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_ltcat',
        tipo: 203,
        label: 'Como deseja gerar o LTCAT',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-8',
        type: 'select-tipo',
        field: 'id_tipo_revisao',
        tipo: 1,
        label: 'Tipo da Revisão',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'date',
        field: 'data',
        label: 'Data Documento',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-revisao',
        field: 'id_rev',
        label: 'Selecione o PPRA para copiar',
        info: '',
        option: {
            key: 'id',
            label: 'revisao',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-revisao',
        field: 'id_ltcat',
        option: {
            key: 'id',
            label: 'revisao',
            value: 'id'
        },
        label: 'Selecione o LTCAT para copiar',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        maxlength:500,
        info: '',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/_form/ltcat-cadastrar.js